import { typedStyles } from '@/utils/styleUtils';

export const styles = typedStyles({
  dropDown: {
    height: 512,
    borderRadius: 4,
    marginTop: 2,
  },

  pane: {
    display: 'flex',
    flexDirection: 'column',
  },

  search: ({ spacing }) => ({
    padding: spacing(2.5, 3),
  }),

  searchInput: {
    borderRadius: '24px',
    background: 'transparent',

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: 1,
    },

    '& .MuiInputBase-input': {
      paddingLeft: 0,
      fontWeight: 500,

      '&::placeholder': {
        color: 'text.disabled',
        opacity: 1,
      },
    },
  },

  searchIcon: {
    color: 'text.disabled',
    pointerEvents: 'none',
  },

  showSelected: ({ spacing, shadows }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: spacing(2, 3),
    boxShadow: shadows[3],
    cursor: 'pointer',
  }),

  options: {
    position: 'relative',
    minHeight: 0,
    flex: 1,
  },

  optionsList: {
    paddingTop: 0,
    maxHeight: '100%',
    overflowY: 'auto',
  },

  selectAll: ({ spacing }) => ({
    position: 'sticky',
    top: 0,
    zIndex: 1,
    padding: spacing(2, 3),
    backgroundColor: 'background.paper',

    '[data-scrolled="true"] > &': {
      boxShadow: 3,
    },
  }),

  item: ({ spacing }) => ({
    display: 'grid',
    gridTemplate: '"checkbox ." auto "checkbox ." auto / auto 1fr',
    padding: spacing(1, 3),
    columnGap: 2,
  }),

  nothingFound: ({ spacing }) => ({
    marginTop: '10%',
    padding: spacing(2, 3),
    textAlign: 'center',
  }),

  itemCheckbox: {
    gridArea: 'checkbox',
    margin: 0,
  },

  selectedHeader: {
    display: 'grid',
    gridTemplateColumns: '40px 1fr 40px',
    placeItems: 'center',
    padding: 3,
  },
});
